import React, { useEffect } from 'react'
import './err500.scss';

export default function Err500() {

  // Nombre de la página
  const namePage = 'Error con el servidor';

  useEffect(() => {

    // Titulos de pagina
    document.title = namePage;

  }, []);

  return (
    <section className='content_page_error_server'>
      <div className='page_error_server'>

        <div className='title_element'>
          <span className='title'>500</span>
          <span className='divisor'>|</span>
          <span className='subtitle'>EL SERVIDOR HA FALLADO</span>
        </div>

        <div className='description_element'>
          <span>Tenemos complicaciones con nuestro servidor, por favor inténtelo más tarde mientras solucionamos los inconvenientes actuales.</span>
        </div>

      </div>
    </section>
  )
}
